import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule, registerLocaleData } from '@angular/common';
import LocaleRu from '@angular/common/locales/ru';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IconsProviderModule } from './icons-provider.module';
import { UIModule } from './ui/ui.module';
import { NzShareModule } from './nz/nz-share.module';
import { LoginComponent } from './modules/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TextMaskModule } from 'angular2-text-mask';
import { MainComponent } from './pages/main/main.component';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { SettingsModule } from './modules/settings/settings.module';
import { NZ_I18N, ru_RU } from 'ng-zorro-antd/i18n';
import {RegistrationComponent} from "./modules/registration/registration.component";
import {CodeConfirmModule} from "./global-components/code-confirm/code-confirm.module";
import { ChatModule } from './modules/chat/chat.module';
import { SharedModule } from './modules/shared/shared.module';
import { GalleryImageComponent } from './global-components/gallery-image/gallery-image.component';
import { Router } from "@angular/router";
import * as Sentry from '@sentry/angular-ivy';
import { RequestComponent } from "./pages/request/request.component";
import { HelpComponent } from './pages/help/help.component';
import { BalanceModule } from './global-components/balance/balance.module';

registerLocaleData(LocaleRu);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegistrationComponent,
    MainComponent,
    GalleryImageComponent,
    RequestComponent,
    HelpComponent,
  ],
    imports: [
        ChatModule,
        SharedModule,
        UIModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        IconsProviderModule,
        NzShareModule,
        ReactiveFormsModule,
        TextMaskModule,
        SettingsModule,
        CodeConfirmModule,
        BalanceModule,
    ],
  providers: [
    { provide: LOCALE_ID, useValue: 'ru' },
    { provide: NZ_I18N, useValue: ru_RU },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
